var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8A373498-955E-4C5F-AEE8-1A094817D48F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-214.000000, -4988.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AppStorePublish",
    transform: "translate(214.000000, 4988.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "App-Store-Copy-3",
    fontFamily: "Inter-Medium, Inter",
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: -0.548571416,
    fill: "#090F36"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24,
    y: 69
  }, "App Store")), /*#__PURE__*/React.createElement("path", {
    d: "M54.1157016,33.0422139 L54.402149,33.0590357 C55.124371,33.089799 57.1523462,33.3529982 58.4521949,35.2756594 C58.3477273,35.3401884 56.0329144,36.7019035 56.0596667,39.527329 C56.0901572,42.9081776 58.999321,44.0350518 59.0317912,44.046954 C59.0062002,44.1261595 58.5667066,45.651243 57.4993911,47.2267236 C56.576109,48.58683 55.6177828,49.942985 54.1105862,49.9703602 C52.6250084,49.9985471 52.1488971,49.0846491 50.4536089,49.0846491 C48.7596909,49.0846491 48.2308614,49.9429843 46.8263332,49.9985471 C45.3702908,50.053748 44.2598942,48.5256845 43.3308876,47.1711108 C41.4274516,44.3971159 39.9745247,39.3330171 41.9263733,35.9136479 C42.8949275,34.215914 44.6278064,33.1404346 46.5090133,33.1140425 C47.9377208,33.0856405 49.2893203,34.0845071 50.1622399,34.0845071 C51.0375372,34.0845071 52.678128,32.8843772 54.402149,33.0590357 Z M54.8464228,28 C54.9929669,29.2798293 54.4581044,30.5633536 53.6609786,31.4883129 C52.8634479,32.4114921 51.5559894,33.1284343 50.2760749,33.033158 C50.1007621,31.7801238 50.7472988,30.4735226 51.4860574,29.6552877 C52.3079125,28.7332155 53.699075,28.0436379 54.8464228,28 Z",
    id: "Combined-Shape",
    fill: "#090F36",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishAppStore);
export default __webpack_public_path__ + "static/media/PublishAppStore.441c115851724b156e9b1afaf9d39ca5.svg";
export { ForwardRef as ReactComponent };